/**
 * Here, we provide an easy to use, Promise-based
 * interface for communicating with the Shopify Cart
 * API.
 *
 * Examples:
 * import cart from 'lib/cart'
 *
 * cart
 *  .get()
 *  .then(data => {
 *    console.log(data)
 *  })
 *
 * cart
 *  .add({id: variantID, quantity: 1})
 *  .then(data => {
 *    console.log(data)
 *  })
 *
 * cart
 *  .update({id: variantID, quantity: 1})
 *  .then(data => {
 *    console.log(data)
 *  })
 */
class Cart {
  get () {
    return fetch('/cart.js')
      .then(res => res.json())
  }

  generateShopifyCartBody (mode, { id, quantity, properties = {} }) {
    const props = Object.keys(properties).reduce((arr, key) => {
      arr.push(`properties[${key}]=${properties[key]}`)
      return arr
    }, []).join('&')
    if (mode === 'add') {
      return `quantity=${quantity}&id=${id}${props ? '&' + props : ''}`
    } else {
      return `updates[${id}]=${quantity}${props ? '&' + props : ''}`
    }
  }

  update (data) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: this.generateShopifyCartBody('update', data)
    })
      .then(res => res.json())
      .then(cart => {
        if (cart.status && cart.status !== 200) {
          cart.errors = [cart.description]
        }
        return cart
      })
  }

  /**
   * Adds a product to the Shopify cart
   *
   * @param {Object} data {id: <id>, quantity: <Number>}
   */
  add (data) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: this.generateShopifyCartBody('add', data)
    })
      .then(res => res.json())
      .then(cart => {
        if (cart.status && cart.status !== 200) {
          cart.errors = [cart.description]
        }
        return cart
      })
  }
}

export default new Cart()
